/* eslint-disable no-console */

// Events
import { VIDEO_ENTER_FULLSCREEN, VIDEO_EXIT_FULLSCREEN, VIDEO_PLAY, VIDEO_STOP } from 'events';
import { component } from 'picoapp';

// Utils
import choozy from 'utils/choozy';

export default component((node, ctx) => {
  const { video: videos, content, playButton } = choozy(node);

  const { videoId } = node.dataset;
  const onlyFullscreen = node.dataset.onlyFullscreen === 'true';
  const overlayOnPause = node.dataset.overlayOnPause === 'true';
  const isLooped = node.dataset.looped === 'true';

  // Middleware
  const authenticateVideoId = (cb) => (state, id) =>
    id.toString() === videoId ? cb(state, id) : null;

  const emitEvent = (name) => {
    const event = new CustomEvent(name, {
      bubbles: true,
      cancelable: true,
    });
    node.dispatchEvent(event);
  };

  [].concat(videos).forEach((video) => {
    const isAutoplay = video.autoplay;

    if (isAutoplay) return;

    // Events
    ctx.on(
      VIDEO_ENTER_FULLSCREEN,
      authenticateVideoId(() => {
        try {
          if (video.requestFullscreen) {
            video.requestFullscreen();
          } else if (video.mozRequestFullScreen) {
            video.mozRequestFullScreen();
          } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
          } else if (video.msRequestFullscreen) {
            video.msRequestFullscreen();
          }
        } catch (err) {
          console.error(err);
        }
      }),
    );

    ctx.on(
      VIDEO_EXIT_FULLSCREEN,
      authenticateVideoId(() => {
        if (!document.fullscreenElement) return;

        try {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        } catch (err) {
          console.error(err);
        }
      }),
    );

    ctx.on(
      VIDEO_PLAY,
      authenticateVideoId(() => {
        content.classList.add('hidden');
        video.classList.remove('hidden');

        video.play();
        emitEvent('video:play');
      }),
    );

    ctx.on(
      VIDEO_STOP,
      authenticateVideoId(() => {
        video.pause();
        video.currentTime = 0;

        content.classList.remove('hidden');
        video.classList.add('hidden');
      }),
    );

    if (playButton) {
      playButton.addEventListener('click', () => {
        ctx.emit(onlyFullscreen ? [VIDEO_PLAY, VIDEO_ENTER_FULLSCREEN] : VIDEO_PLAY, null, videoId);
      });
    }

    video.addEventListener('ended', () => {
      if (isLooped) return;

      video.currentTime = 0;

      if (content) content.classList.remove('hidden');
      video.classList.add('hidden');

      ctx.emit(VIDEO_EXIT_FULLSCREEN, null, videoId);

      emitEvent('video:ended');
    });

    video.addEventListener('pause', () => {
      if (isLooped) return;
      if (overlayOnPause) ctx.emit(VIDEO_STOP, null, videoId);

      emitEvent('video:ended');
    });

    video.addEventListener('play', () => {
      if (isLooped) return;
      emitEvent('video:play');
    });
  });
});
